export const Pagination = {
  smallRowsPerPage: 5,
  mediumRowsPerPage: 10,
  rowsPerPage: 15,
  largeRowsPerPage: 50,
  rowsPerPageOptions: [3, 5, 7, 10, 15, 20, 25, 50]
}
